<template>
  <div class="gd-snackbar">
    <div class="gd-snackbar__text" v-html="message"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'snackbar',

  computed: {
    ...mapState('app', {
      message: state => state.snackbar.message,
      active: state => state.snackbar.active,
    }),
  },

  methods: {
    ...mapActions({
      apiCloseSnackbar: 'app/closeSnackbar',
    }),
  },

  watch: {
    active(active) {
      if (active) {
        this.$el.classList.add('open-snackbar');
        setTimeout(() => {
          this.$el.classList.remove('open-snackbar');
        }, 5000);
        setTimeout(() => {
          this.apiCloseSnackbar();
        }, 6000);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Snackbar.vue